import { useCallback, useEffect, useState } from "react";
import { setCaseId } from "../../../store/actions";
import { withRouter, Link } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import overlayFactory from 'react-bootstrap-table2-overlay';
import paginationFactory, {
    PaginationProvider,
    PaginationListStandalone,
    SizePerPageDropdownStandalone,
    PaginationTotalStandalone
} from 'react-bootstrap-table2-paginator';
import {
    API_URL_GET_ANALYST_REPORT_LIST,
    CM_API_URL_GET_ANALYST_REPORT_LIST,
    API_URL_GET_ANALYST_REPORT_LISTS_COUNT,
    CM_API_URL_GET_ANALYST_REPORT_LISTS_COUNT,
    API_URL_GET_REPORT_LIST,
    CM_API_URL_GET_REPORT_LIST,
    API_URL_REPORT_CATEGORY_LIST_CASE,
    CM_API_URL_REPORT_CATEGORY_LIST_CASE,
    INTERNATIONAL_DATE_FORMAT,
    EMPTY_LIST,
} from "../../../common/constants";
import {
    Alert,
    Card,
    CardBody,
    Col,
    Container,
    Nav,
    NavItem,
    NavLink,
    Row,
    Spinner,
    TabContent,
    TabPane,
} from "reactstrap";
import axios from "axios";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { isFeatureEnabledForActiveModule } from 'src/helpers/module_helper';
import anonyReportImage from "../../../assets/images/report_anonymously.svg";
import confidentlyReportImage from "../../../assets/images/report_confidently.svg";
import arrangeMeetingImage from "../../../assets/images/arrange_meeting.svg";
import voice_report from "../../../assets/images/microphone.svg";
import DateUtils from "../../../services/utils/DateUtils";
import {
    REPORT_STATUS_LIST,
    REPORT_ANONYMIZATION_OPTIONS
} from "../../../components/constants";
import classnames from "classnames";
import { TbLoader } from "react-icons/tb";
import FilteringComponent from "./components/FilteringComponent";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";

const ReportsList = ({
    t,
    modules,
    token,

    onSetCaseId
}) => {
    const dateUtils = new DateUtils();

    const [ filters, setFilters ] = useState({
        pageIndex: 1,
        pageSize: 25,
        activeTab: 'all_reports',
        status: null,
        categories: [],
        risk: null,
        caseId: null,
        exclude: [],
        assignedAnalyst: null,
        anonymization: [],
        sortField: null,
        sortOrder: null
    });

    const {
        data: reportsData,
        isFetching: reportsAreFetching,
        isFetched: reportsAreFetched
    } = useQuery({
        queryKey: [
            "app-fetch-reports-list",
            modules.active,
            filters
        ],
        queryFn: async () => {
            let url = '';

            if(filters.activeTab === 'reported_by_me'){
                url = modules.active === 'wb' ? API_URL_GET_REPORT_LIST : CM_API_URL_GET_REPORT_LIST;
            }
            else {
                url = modules.active === 'wb' ? API_URL_GET_ANALYST_REPORT_LIST : CM_API_URL_GET_ANALYST_REPORT_LIST;
            }

            const response = await axios.post(url,
                {
                    ...filters,
                    categories: (filters.categories || []).map((category) => ({
                        value: category
                    })),

                    assignedToMe: filters.activeTab === 'assigned_to_me' ? true : undefined,
                    caseId: filters.caseId || undefined,
                    status: filters.activeTab === 'deleted_reports' ? 5 : filters.status,
                    
                    excludeDeleted: filters.exclude?.includes('excludeDeleted') ? true : undefined,
                    excludeTestCases: filters.exclude?.includes('excludeTestCases') ? true : undefined,
                    exclude: undefined,
                    
                    isAnonymized: filters.anonymization?.includes('onlyAnonymized') ? true : undefined,
                    anonymization: undefined,

                    activeTab: undefined
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            return response.data?.data;
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        enabled: isFeatureEnabledForActiveModule("list-cases"),
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t("An error occurred while fetching the reports list."), {
                type: "error"
            });
        }
    });

    const categoriesQuery = useQuery({
        queryKey: [
            "app-fetch-reports-categories-list",
            modules.active
        ],
        queryFn: async () => {
            const respones = await axios.post(
                modules.active === "wb" ? API_URL_REPORT_CATEGORY_LIST_CASE : CM_API_URL_REPORT_CATEGORY_LIST_CASE,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            return respones.data?.data;
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        enabled: isFeatureEnabledForActiveModule("list-cases"),
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t("An error occurred while fetching the report categories list."), {
                type: "error"
            });
        }
    });

    const {
        isFetching: reportsCountsAreFetching,
        data: reportsCounts
    } = useQuery({
        queryKey: [
            "app-fetch-reports-counts",
            modules.active
        ],
        queryFn: async () => {
            const respones = await axios.get(
                modules.active === "wb"
                    ? API_URL_GET_ANALYST_REPORT_LISTS_COUNT
                    : CM_API_URL_GET_ANALYST_REPORT_LISTS_COUNT,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            return respones.data?.data;
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        enabled: isFeatureEnabledForActiveModule("list-cases"),
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t("An error occurred while fetching the report counts."), {
                type: "error"
            });
        }
    });

    const handleFilterChange = useCallback((newFitlers) => {
        setFilters((currentState) => {
            return {
                ...currentState,
                ...newFitlers,
                pageIndex: 1
            }
        });
    }, []);

    const handleTableChange = useCallback((type, options) => {
        const {
            page,
            sizePerPage,

            sortField,
            sortOrder
        } = options;

        switch(type){
            case 'pagination':
                    setFilters((currentState) => {
                        return {
                            ...currentState,
                            pageIndex: page,
                            pageSize:   sizePerPage
                        }
                    });
                break;
            case 'sort':
                    setFilters((currentState) => {
                        return {
                            ...currentState,
                            sortField: sortField,
                            sortOrder:   sortOrder.toUpperCase()
                        }
                    });
                break;
            default:
                return false;
        }
    }, []);

    const changeActiveTab = (tab) => {
        setFilters((currentState) => {
            return {
                ...currentState,
                activeTab: tab,
                pageIndex: 1
            }
        })
    }

    const columns = [
        {
            dataField: "risk_type",
            text: t("Risk"),
            sort: false,
            formatter: (_cell, { risk }) => {
                return (
                    <span
                        style={{ backgroundColor: `#${risk}` }}
                        className="risk-rate"
                    ></span>
                )
            }
        },
        {
            dataField: "type",
            text: t("Type"),
            sort: false,
            formatter: (cellContent) => {
                switch (cellContent) {
                    case 1:
                        return (
                            <img
                                alt="Anonymously"
                                className="rounded-circle"
                                style={{ width: "36px" }}
                                src={anonyReportImage}
                            />
                        );
                    case 2:
                        return (
                            <img
                                alt="Confidential"
                                className="rounded-circle"
                                style={{ width: "36px" }}
                                src={confidentlyReportImage}
                            />
                        );
                    case 3:
                        return (
                            <img
                                alt="Meeting"
                                className="rounded-circle"
                                style={{ width: "36px" }}
                                src={arrangeMeetingImage}
                            />
                        );
                    case 4:
                        return (
                            <img
                                alt="Voice"
                                className="rounded-circle"
                                style={{ width: "36px" }}
                                src={voice_report}
                            />
                        );
                    default: 
                        return null;
                }
            }
        },
        {
            dataField: "case_id",
            text: t("Case ID"),
            sort: false,
            style: {
                display: "table-cell",
                maxWidth: "200px"
            },
            headerStyle: {
                minWidth: "200px",
                maxWidth: "200px"
            },
            formatter: (_cell, {
                case_id,
                secondary_case_id
            }) => {
                return (
                    <Link
                        className="text-dark"
                        to={`/admin/report/detail`}
                        onClick={() => {
                            localStorage.setItem("caseId", case_id);
                            localStorage.setItem("secondaryCaseId", secondary_case_id);
                            onSetCaseId(case_id);
                        }}
                    >
                        {secondary_case_id}
                    </Link>
                )
            }
        },
        {
            dataField: "description",
            text: t("Description"),
            sort: false,
            formatter: (_cell, {
                admin_description,
                description
            }) => {
                if(admin_description && admin_description.trim()){
                    return admin_description.length > 70 ? `${admin_description.substring(0, 70)}...` : admin_description
                }

                if(description) {
                    return description.length > 70 ? `${description.substring(0, 70)}...` : description
                }

                return null;
            }
        },
        {
            dataField: "category",
            text: t("Category"),
            style: { display: "table-cell", maxWidth: "260px" },
            headerStyle: { maxWidth: "260px" },
            formatter: (_cell, {
                admin_category,
                category
            }) => {
                const reportCategories = admin_category?.length ? admin_category : category;

                return (
                    (categoriesQuery.data?.length ? categoriesQuery.data : []).filter(
                        (i) => (reportCategories || []).includes(i.id)
                    ).map((i) => t(i.title))
                ).join(', ');
            }
        },
        {
            dataField: "source",
            text: t("Channel"),
            sort: true,
            formatter: (cellContent) => {
                return (
                    <div
                        className="badge text-bg-primary"
                        style={{ textTransform: "capitalize" }}
                    >
                        {t(cellContent)}
                    </div>
                )
            }
        },
        {
            dataField: "submission_date",
            text: t("Submission date"),
            sort: true,
            formatter: (cellContent) => {
                return dateUtils.convertTimeStampToDate(
                    cellContent,
                    INTERNATIONAL_DATE_FORMAT
                )
            }
        },
        {
            dataField: "closing_date",
            text: t("Closing date"),
            sort: true,
            formatter: (cellContent) => {
                return dateUtils.convertTimeStampToDate(
                    cellContent,
                    INTERNATIONAL_DATE_FORMAT
                )
            }
        },
        {
            dataField: "analyst_assigned",
            text: t("Assigned analyst"),
            sort: true,
            formatter: (cellContent) => {
                return cellContent.id ? `${cellContent.first_name} ${cellContent.last_name}` : ""
            }
        },
        {
            dataField: "status",
            text: t("Status"),
            sort: true,
            formatter: (_cell, {
                status: statusId,
                is_anonymized,
                status_updating_date
            }) => {
                const status = REPORT_STATUS_LIST.find(
                    (item) => item.id === parseInt(statusId)
                );

                return (
                    <div>
                        <div className={status.className}>
                            {t(status.titleKey)}
                        </div>

                        {is_anonymized && (
                            <div className={REPORT_ANONYMIZATION_OPTIONS.className}>
                                {t(REPORT_ANONYMIZATION_OPTIONS.titleKey)}
                            </div>
                        )}
                        <div>
                            <small className="text-muted">
                                {t("Updated")}:{" "}
                                {dateUtils.convertTimeStampToDate(
                                    status_updating_date,
                                    INTERNATIONAL_DATE_FORMAT
                                )}
                            </small>
                        </div>
                    </div>
                )
            }
        },
    ];

    const NoDataIndication = () => (
        (reportsAreFetched && !reportsData?.reports?.length) ? <div className="alert m-0" role="alert">
            <p style={{
                textAlign: "center",
                marginBottom: 0
            }}>
                {t(EMPTY_LIST)}
            </p>
        </div> : <></>
    );

    return (
        <div className="page-content">
            <Container fluid style={{ minHeight: "400px" }}>
                <Breadcrumbs
                    title={t("Case Management")}
                    breadcrumbItems={[
                        { title: "SIP", link: "/" },
                        { title: t("Case Management"), link: "#" }
                    ]}
                />

                {isFeatureEnabledForActiveModule("list-cases") ? (
                    <div>
                        <Row style={{ position: "relative", zIndex: 10 }}>
                            <Row>
                                <Col className="col-12 col-xl-6">
                                    <Card>
                                        <Nav tabs className="nav-tabs-custom nav-justified">
                                            <NavItem>
                                                <NavLink
                                                    style={{
                                                        cursor: "pointer",
                                                        whiteSpace: "nowrap"
                                                    }}
                                                    className={classnames({
                                                        active: filters.activeTab === "all_reports"
                                                    })}
                                                    onClick={() => {
                                                        changeActiveTab('all_reports')
                                                    }}
                                                >
                                                    <span className="d-block">
                                                        {t("All reports")} {" "}
                                                        {reportsCountsAreFetching ? (
                                                            <TbLoader />
                                                        ) : (
                                                            <>({reportsCounts?.all || 0})</>
                                                        )}
                                                    </span>
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    style={{
                                                        cursor: "pointer",
                                                        whiteSpace: "nowrap"
                                                    }}
                                                    className={classnames({
                                                        active: filters.activeTab === "assigned_to_me",
                                                    })}
                                                    onClick={() => {
                                                        changeActiveTab('assigned_to_me')
                                                    }}
                                                >
                                                    <span className="d-block">
                                                        {t("Assigned to Me")} {" "}
                                                        {reportsCountsAreFetching ? (
                                                            <TbLoader />
                                                        ) : (
                                                            <>({reportsCounts?.assigned_to_me || 0})</>
                                                        )}
                                                    </span>
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    style={{
                                                        cursor: "pointer",
                                                        whiteSpace: "nowrap"
                                                    }}
                                                    className={classnames({
                                                        active: filters.activeTab === "deleted_reports"
                                                    })}
                                                    onClick={() => {
                                                        changeActiveTab('deleted_reports')
                                                    }}
                                                >
                                                    <span className="d-block">
                                                        {t("Deleted Cases")} {" "}
                                                        {reportsCountsAreFetching ? (
                                                            <TbLoader />
                                                        ) : (
                                                            <>({reportsCounts?.deleted || 0})</>
                                                        )}
                                                    </span>
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    style={{
                                                        cursor: "pointer",
                                                        whiteSpace: "nowrap"
                                                    }}
                                                    className={classnames({
                                                        active: filters.activeTab === "reported_by_me"
                                                    })}
                                                    onClick={() => {
                                                        changeActiveTab('reported_by_me')
                                                    }}
                                                >
                                                    <span className="d-block">
                                                        {t("Reported By Me")} {" "}
                                                        {reportsCountsAreFetching ? (
                                                            <TbLoader />
                                                        ) : (
                                                            <>({reportsCounts?.my_cases || 0})</>
                                                        )}
                                                    </span>
                                                </NavLink>
                                            </NavItem>
                                        </Nav>
                                    </Card>
                                </Col>
                                <Col
                                    className="col-12 col-xl-6 d-flex justify-content-end align-items-center mb-3"
                                >
                                    <FilteringComponent
                                        onChange={handleFilterChange}
                                        categoriesQuery={categoriesQuery}
                                    />
                                </Col>
                            </Row>
                        </Row>

                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody className="pt-0">
                                        <TabContent activeTab={filters.activeTab}>
                                            {/* all_reports */}
                                            <TabPane tabId="all_reports" className="p-3">
                                                <PaginationProvider
                                                    pagination={
                                                        paginationFactory({
                                                            custom: true,
                                                            page: filters.pageIndex,
                                                            sizePerPage: filters.pageSize,
                                                            totalSize: reportsData?.itemsCount || 0,
                                                            withFirstAndLast: true,
                                                            alwaysShowAllBtns: true,
                                                            prePageText: <span><i className="ri-arrow-left-s-line"></i> {t('Back')}</span>,
                                                            nextPageText: <span>{t('Next')} <i className="ri-arrow-right-s-line"></i></span>,
                                                            prePageTitle: t('Pre page'),
                                                            firstPageTitle: t('First page'),
                                                            lastPageTitle: t('Last page'),
                                                            showTotal: false,
                                                            paginationTotalRenderer: (from, to, size) => {
                                                                return (
                                                                    <span className="react-bootstrap-table-pagination-total">
                                                                        {`${t('Total Items')} ${size}`}
                                                                    </span>
                                                                )
                                                            },
                                                            hideSizePerPage: false,
                                                            sizePerPageList: [
                                                                {
                                                                    text: '25',
                                                                    value: 25
                                                                },
                                                                {
                                                                    text: '50',
                                                                    value: 50
                                                                }
                                                            ]
                                                        })
                                                    }>
                                                    {
                                                        ({
                                                            paginationProps,
                                                            paginationTableProps
                                                        }) => (
                                                            <>
                                                                <Row>
                                                                    <Col sm="12">
                                                                        <BootstrapTable
                                                                            remote={{
                                                                                pagination: true,
                                                                                filter: false,
                                                                                sort: true,
                                                                                cellEdit: false,
                                                                                search: false
                                                                            }}
                                                                            loading={reportsAreFetching}
                                                                            overlay={overlayFactory({ spinner: <Spinner animation="border" variant="primary" size="md" />, text: `${t("Loading")}...` })}
                                                                            onTableChange={handleTableChange}
                                                                            defaultSorted={[]}
                                                                            keyField={"case_id"}
                                                                            striped={false}
                                                                            responsive={true}
                                                                            bordered={false}
                                                                            data={reportsData?.reports || []}
                                                                            columns={columns}
                                                                            wrapperClasses="table-responsive"
                                                                            classes={"table"}
                                                                            headerWrapperClasses={"thead-light"}
                                                                            noDataIndication={() => <NoDataIndication />}
                                                                            {...paginationTableProps}
                                                                        />
                                                                    </Col>
                                                                </Row>

                                                                <Row>
                                                                    <Col sm="12">
                                                                        <div className="tpdd-pagination-style-1 justify-content-between">
                                                                            <PaginationTotalStandalone
                                                                                {...paginationProps}
                                                                            />

                                                                            <div>
                                                                                <PaginationListStandalone
                                                                                    {...paginationProps}
                                                                                />

                                                                                <SizePerPageDropdownStandalone
                                                                                    {...paginationProps}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </>
                                                        )
                                                    }

                                                </PaginationProvider>
                                            </TabPane>

                                            {/* assigned_to_me */}
                                            <TabPane tabId="assigned_to_me" className="p-3">
                                                <PaginationProvider
                                                    pagination={
                                                        paginationFactory({
                                                            custom: true,
                                                            page: filters.pageIndex,
                                                            sizePerPage: filters.pageSize,
                                                            totalSize: reportsData?.itemsCount || 0,
                                                            withFirstAndLast: true,
                                                            alwaysShowAllBtns: true,
                                                            prePageText: <span><i className="ri-arrow-left-s-line"></i> {t('Back')}</span>,
                                                            nextPageText: <span>{t('Next')} <i className="ri-arrow-right-s-line"></i></span>,
                                                            prePageTitle: t('Pre page'),
                                                            firstPageTitle: t('First page'),
                                                            lastPageTitle: t('Last page'),
                                                            showTotal: false,
                                                            paginationTotalRenderer: (from, to, size) => {
                                                                return (
                                                                    <span className="react-bootstrap-table-pagination-total">
                                                                        {`${t('Total Items')} ${size}`}
                                                                    </span>
                                                                )
                                                            },
                                                            hideSizePerPage: false,
                                                            sizePerPageList: [
                                                                {
                                                                    text: '25',
                                                                    value: 25
                                                                },
                                                                {
                                                                    text: '50',
                                                                    value: 50
                                                                }
                                                            ]
                                                        })
                                                    }>
                                                    {
                                                        ({
                                                            paginationProps,
                                                            paginationTableProps
                                                        }) => (
                                                            <>
                                                                <Row>
                                                                    <Col sm="12">
                                                                        <BootstrapTable
                                                                            remote={{
                                                                                pagination: true,
                                                                                filter: false,
                                                                                sort: true,
                                                                                cellEdit: false,
                                                                                search: false
                                                                            }}
                                                                            loading={reportsAreFetching}
                                                                            overlay={overlayFactory({ spinner: <Spinner animation="border" variant="primary" size="md" />, text: `${t("Loading")}...` })}
                                                                            onTableChange={handleTableChange}
                                                                            defaultSorted={[]}
                                                                            keyField={"case_id"}
                                                                            responsive={true}
                                                                            bordered={false}
                                                                            data={reportsData?.reports || []}
                                                                            striped={false}
                                                                            columns={columns}
                                                                            wrapperClasses="table-responsive"
                                                                            classes={"table"}
                                                                            headerWrapperClasses={"thead-light"}
                                                                            noDataIndication={() => <NoDataIndication />}
                                                                            {...paginationTableProps}
                                                                        />
                                                                    </Col>
                                                                </Row>

                                                                <Row>
                                                                    <Col sm="12">
                                                                        <div className="tpdd-pagination-style-1 justify-content-between">
                                                                            <PaginationTotalStandalone
                                                                                {...paginationProps}
                                                                            />

                                                                            <div>
                                                                                <PaginationListStandalone
                                                                                    {...paginationProps}
                                                                                />

                                                                                <SizePerPageDropdownStandalone
                                                                                    {...paginationProps}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </>
                                                        )
                                                    }

                                                </PaginationProvider>
                                            </TabPane>

                                            {/* deleted_reports */}
                                            <TabPane tabId="deleted_reports" className="p-3">
                                                <PaginationProvider
                                                    pagination={
                                                        paginationFactory({
                                                            custom: true,
                                                            page: filters.pageIndex,
                                                            sizePerPage: filters.pageSize,
                                                            totalSize: reportsData?.itemsCount || 0,
                                                            withFirstAndLast: true,
                                                            alwaysShowAllBtns: true,
                                                            prePageText: <span><i className="ri-arrow-left-s-line"></i> {t('Back')}</span>,
                                                            nextPageText: <span>{t('Next')} <i className="ri-arrow-right-s-line"></i></span>,
                                                            prePageTitle: t('Pre page'),
                                                            firstPageTitle: t('First page'),
                                                            lastPageTitle: t('Last page'),
                                                            showTotal: false,
                                                            paginationTotalRenderer: (from, to, size) => {
                                                                return (
                                                                    <span className="react-bootstrap-table-pagination-total">
                                                                        {`${t('Total Items')} ${size}`}
                                                                    </span>
                                                                )
                                                            },
                                                            hideSizePerPage: false,
                                                            sizePerPageList: [
                                                                {
                                                                    text: '25',
                                                                    value: 25
                                                                },
                                                                {
                                                                    text: '50',
                                                                    value: 50
                                                                }
                                                            ]
                                                        })
                                                    }>
                                                    {
                                                        ({
                                                            paginationProps,
                                                            paginationTableProps
                                                        }) => (
                                                            <>
                                                                <Row>
                                                                    <Col sm="12">
                                                                        <BootstrapTable
                                                                            remote={{
                                                                                pagination: true,
                                                                                filter: false,
                                                                                sort: true,
                                                                                cellEdit: false,
                                                                                search: false
                                                                            }}
                                                                            loading={reportsAreFetching}
                                                                            overlay={overlayFactory({ spinner: <Spinner animation="border" variant="primary" size="md" />, text: `${t("Loading")}...` })}
                                                                            onTableChange={handleTableChange}
                                                                            defaultSorted={[]}
                                                                            keyField={"case_id"}
                                                                            responsive={true}
                                                                            bordered={false}
                                                                            data={reportsData?.reports || []}
                                                                            striped={false}
                                                                            columns={columns}
                                                                            wrapperClasses="table-responsive"
                                                                            classes={"table"}
                                                                            headerWrapperClasses={"thead-light"}
                                                                            noDataIndication={() => <NoDataIndication />}
                                                                            {...paginationTableProps}
                                                                        />
                                                                    </Col>
                                                                </Row>

                                                                <Row>
                                                                    <Col sm="12">
                                                                        <div className="tpdd-pagination-style-1 justify-content-between">
                                                                            <PaginationTotalStandalone
                                                                                {...paginationProps}
                                                                            />

                                                                            <div>
                                                                                <PaginationListStandalone
                                                                                    {...paginationProps}
                                                                                />

                                                                                <SizePerPageDropdownStandalone
                                                                                    {...paginationProps}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </>
                                                        )
                                                    }
                                                </PaginationProvider>
                                            </TabPane>

                                            {/* reported_by_me */}
                                            <TabPane tabId="reported_by_me" className="p-3">
                                                <PaginationProvider
                                                    pagination={
                                                        paginationFactory({
                                                            custom: true,
                                                            page: filters.pageIndex,
                                                            sizePerPage: filters.pageSize,
                                                            totalSize: reportsData?.itemsCount || 0,
                                                            withFirstAndLast: true,
                                                            alwaysShowAllBtns: true,
                                                            prePageText: <span><i className="ri-arrow-left-s-line"></i> {t('Back')}</span>,
                                                            nextPageText: <span>{t('Next')} <i className="ri-arrow-right-s-line"></i></span>,
                                                            prePageTitle: t('Pre page'),
                                                            firstPageTitle: t('First page'),
                                                            lastPageTitle: t('Last page'),
                                                            showTotal: false,
                                                            paginationTotalRenderer: (from, to, size) => {
                                                                return (
                                                                    <span className="react-bootstrap-table-pagination-total">
                                                                        {`${t('Total Items')} ${size}`}
                                                                    </span>
                                                                )
                                                            },
                                                            hideSizePerPage: false,
                                                            sizePerPageList: [
                                                                {
                                                                    text: '25',
                                                                    value: 25
                                                                },
                                                                {
                                                                    text: '50',
                                                                    value: 50
                                                                }
                                                            ]
                                                        })
                                                    }>
                                                    {
                                                        ({
                                                            paginationProps,
                                                            paginationTableProps
                                                        }) => (
                                                            <>
                                                                <Row>
                                                                    <Col sm="12">
                                                                        <BootstrapTable
                                                                            remote={{
                                                                                pagination: true,
                                                                                filter: false,
                                                                                sort: true,
                                                                                cellEdit: false,
                                                                                search: false
                                                                            }}
                                                                            loading={reportsAreFetching}
                                                                            overlay={overlayFactory({ spinner: <Spinner animation="border" variant="primary" size="md" />, text: `${t("Loading")}...` })}
                                                                            onTableChange={handleTableChange}
                                                                            defaultSorted={[]}
                                                                            keyField={"case_id"}
                                                                            responsive={true}
                                                                            bordered={false}
                                                                            data={reportsData?.reports || []}
                                                                            striped={false}
                                                                            columns={columns}
                                                                            wrapperClasses="table-responsive"
                                                                            classes={"table"}
                                                                            headerWrapperClasses={"thead-light"}
                                                                            noDataIndication={() => <NoDataIndication />}
                                                                            {...paginationTableProps}
                                                                        />
                                                                    </Col>
                                                                </Row>

                                                                <Row>
                                                                    <Col sm="12">
                                                                        <div className="tpdd-pagination-style-1 justify-content-between">
                                                                            <PaginationTotalStandalone
                                                                                {...paginationProps}
                                                                            />

                                                                            <div>
                                                                                <PaginationListStandalone
                                                                                    {...paginationProps}
                                                                                />

                                                                                <SizePerPageDropdownStandalone
                                                                                    {...paginationProps}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </>
                                                        )
                                                    }
                                                </PaginationProvider>
                                            </TabPane>
                                        </TabContent>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                ) : (
                    <Alert color="warning">
                        {t(
                            "You do not have permission to access these pages"
                        )}
                    </Alert>
                )}
            </Container>
        </div>
    )
}

const mapStatetoProps = (state) => {
    const { user, token } = state.Login;
    const { App } = state;
    const {
        Modules: modules
    } = state;

    return {
        token,
        user,
        App,
        modules
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onSetCaseId: (caseId) => dispatch(setCaseId(caseId))
    };
};

export default withNamespaces()(
  withRouter(connect(mapStatetoProps, mapDispatchToProps)(ReportsList))
);
